import React from 'react'

export default () => (
  <div className='not-found-holder'>
    Not Found =(
    <div className='not-found-bar' />
  </div>
)
